<template>
	<div class="stats-page">
		<div class="stats-header">
			<div class="header-title">
				<h2>出号统计</h2>
			</div>
			<div class="header-tabs">
				<div 
					class="tab-item" 
					:class="{ active: activeTab === 'overview' }"
					@click="handleTabChange('overview')">
					<i class="el-icon-data-line"></i>
					<span>概览</span>
				</div>
				<div 
					class="tab-item" 
					:class="{ active: activeTab === 'detail' }"
					@click="handleTabChange('detail')">
					<i class="el-icon-pie-chart"></i>
					<span>详细</span>
				</div>
				<div 
					class="tab-item" 
					:class="{ active: activeTab === 'list' }"
					@click="handleTabChange('list')">
					<i class="el-icon-document"></i>
					<span>列表</span>
				</div>
			</div>
		</div>
		
		<div class="stats-filter">
			<div class="filter-left" v-if="!isBound">
				<span class="filter-label">管理员：</span>
				<el-select v-model="selectedAdminId" placeholder="全部管理员" clearable @change="handleQuery">
					<el-option 
						v-for="admin in adminList" 
						:key="admin.id" 
						:label="admin.nickname || admin.username" 
						:value="admin.id">
					</el-option>
				</el-select>
			</div>
			<div class="filter-right">
				<span class="filter-label">时间筛选：</span>
				<el-date-picker
					v-model="dateRange"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
					@change="handleDateChange"
					clearable>
				</el-date-picker>
			</div>
		</div>
		
		<div class="stats-content">
			<StatsOverview 
				v-if="activeTab === 'overview'" 
				:statsData="statsData">
			</StatsOverview>
			
			<StatsDetail 
				v-if="activeTab === 'detail'" 
				:statsData="statsData"
				:trendData="trendData">
			</StatsDetail>
			
			<StatsList 
				v-if="activeTab === 'list'"
				:listData="listData"
				:total="listTotal"
				:loading="listLoading"
				:actionType="listActionType"
				:keyword="listKeyword"
				:page="listPage"
				:limit="listLimit"
				@update:actionType="val => listActionType = val"
				@update:keyword="val => listKeyword = val"
				@update:page="val => listPage = val"
				@update:limit="val => listLimit = val"
				@query="getListData">
			</StatsList>
		</div>
	</div>
</template>

<script>
import StatsOverview from './stats/StatsOverview.vue';
import StatsDetail from './stats/StatsDetail.vue';
import StatsList from './stats/StatsList.vue';

export default {
	name: 'AdminStats',
	components: {
		StatsOverview,
		StatsDetail,
		StatsList
	},
	data() {
		return {
			activeTab: 'overview',
			timeType: 'today',
			dateRange: [],
			selectedAdminId: null,
			adminList: [],
			statsData: {
				total_publish: 0,
				total_pulloff: 0,
				total_delete: 0,
				pulloff_reasons: {},
				delete_reasons: {}
			},
			trendData: {
				dates: [],
				publish: [],
				pulloff: [],
				delete: []
			},
			listActionType: '',
			listKeyword: '',
			listPage: 1,
			listLimit: 20,
			listTotal: 0,
			listData: [],
			listLoading: false,
			pickerOptions: {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '昨日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
							start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近3天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3 * 24 * 60 * 60 * 1000);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 7 * 24 * 60 * 60 * 1000);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 30 * 24 * 60 * 60 * 1000);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近90天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 90 * 24 * 60 * 60 * 1000);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			}
		};
	},
	computed: {
		login() {
			return this.$store.getters.login;
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		isBound() {
			return this.statsData.is_bound === false ? false : true;
		}
	},
	watch: {
		timeType() {
			this.getStatsData();
		},
		dateRange(newVal) {
			if (newVal && newVal.length === 2) {
				this.getStatsData();
			}
		},
		selectedAdminId() {
			this.getStatsData();
		}
	},
	created() {
		if (this.isAdmin) {
			this.getAdminList();
			this.getStatsData();
		}
	},
	methods: {
		handleTabChange(tab) {
			this.activeTab = tab;
			if (tab === 'list') {
				this.getListData();
			} else {
				this.getStatsData();
			}
		},
		handleDateChange(val) {
			if (!val) {
				this.timeType = 'today';
				this.dateRange = [];
			}
			this.handleQuery();
		},
		handleQuery() {
			if (this.activeTab === 'list') {
				this.listPage = 1;
				this.getListData();
			} else {
				this.getStatsData();
			}
		},
		getAdminList() {
			this.rq.requests.post('api/game/hall/getAllAdminList').then(res => {
				if (res.code === 1) {
					this.adminList = res.data || [];
				}
			}).catch(err => {
				console.error('getAdminList error:', err);
			});
		},
		getStatsData() {
			const params = {};
			
			if (this.dateRange && this.dateRange.length === 2) {
				params.start_date = Math.floor(new Date(this.dateRange[0]).getTime() / 1000);
				params.end_date = Math.floor(new Date(this.dateRange[1]).getTime() / 1000) + 86400;
			} else {
				params.time_type = this.timeType;
			}
			
			if (!this.isBound && this.selectedAdminId) {
				params.admin_id = this.selectedAdminId;
			}
			this.rq.requests.post('api/game/hall/getAdminStats', params).then(res => {
				if (res.code === 1) {
					this.statsData = res.data || {};
				}
			}).catch(err => {
				console.error('getStatsData error:', err);
			});
			
			this.getTrendData();
		},
		getTrendData() {
			const params = {
				time_type: '7days'
			};
			
			if (this.dateRange && this.dateRange.length === 2) {
				params.start_date = Math.floor(new Date(this.dateRange[0]).getTime() / 1000);
				params.end_date = Math.floor(new Date(this.dateRange[1]).getTime() / 1000) + 86400;
			}
			
			if (!this.isBound && this.selectedAdminId) {
				params.admin_id = this.selectedAdminId;
			}
			
			this.rq.requests.post('api/game/hall/getAdminStatsTrend', params).then(res => {
				if (res.code === 1) {
					this.trendData = res.data || {
						dates: [],
						publish: [],
						pulloff: [],
						delete: []
					};
				}
			}).catch(err => {
				console.error('getTrendData error:', err);
			});
		},
		getListData() {
			this.listLoading = true;
			const params = {
				page: this.listPage,
				limit: this.listLimit,
				action_type: this.listActionType,
				keyword: this.listKeyword
			};
			
			if (this.dateRange && this.dateRange.length === 2) {
				params.start_date = Math.floor(new Date(this.dateRange[0]).getTime() / 1000);
				params.end_date = Math.floor(new Date(this.dateRange[1]).getTime() / 1000) + 86400;
			} else {
				params.time_type = this.timeType;
			}
			if (!this.isBound && this.selectedAdminId) {
				params.admin_id = this.selectedAdminId;
			}
			this.rq.requests.post('api/game/hall/getAdminStatsList', params).then(res => {
				if (res.code === 1) {
					this.listData = res.data.list || [];
					this.listTotal = res.data.total || 0;
				}
			}).catch(err => {
				console.error('getListData error:', err);
			}).finally(() => {
				this.listLoading = false;
			});
		}
	}
};
</script>

<style scoped>
.stats-page {
	min-height: 100%;
	background: #f5f7fa;
}

.stats-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 30px;
	background: #fff;
	border-bottom: 1px solid #e8e8e8;
}

.header-title h2 {
	margin: 0;
	font-size: 20px;
	font-weight: 600;
	color: #1a1a1a;
}

.header-tabs {
	display: flex;
	gap: 10px;
}

.tab-item {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 10px 20px;
	background: #f5f7fa;
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.3s;
	font-size: 14px;
	color: #666;
}

.tab-item:hover {
	background: #e8f4e8;
	color: #1f9535;
}

.tab-item.active {
	background: #1f9535;
	color: #fff;
}

.tab-item i {
	font-size: 16px;
}

.stats-filter {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 30px;
	background: #fff;
	border-bottom: 1px solid #e8e8e8;
}

.filter-left,
.filter-right {
	display: flex;
	align-items: center;
	gap: 10px;
}

.filter-label {
	font-size: 14px;
	color: #666;
	white-space: nowrap;
}

.filter-left .el-select,
.filter-right .el-select {
	width: 150px;
}

.stats-content {
	padding-bottom: 20px;
}

@media (max-width: 768px) {
	.stats-header {
		flex-direction: column;
		gap: 15px;
		padding: 15px;
	}
	
	.header-tabs {
		width: 100%;
		justify-content: space-between;
	}
	
	.tab-item {
		flex: 1;
		justify-content: center;
		padding: 8px 10px;
	}
	
	.tab-item span {
		display: none;
	}
	
	.stats-filter {
		flex-direction: column;
		gap: 10px;
		padding: 15px;
	}
	
	.filter-left,
	.filter-right {
		width: 100%;
	}
	
	.filter-left .el-select,
	.filter-right .el-select {
		flex: 1;
	}
}
</style>
